import { isWithName } from '@common/typescript/objects/WithName';

export function defaultGetter<T>(item: T): string {
	if (isWithName(item) && item.name) return item.name;

	return '-';
}
